import React, { createContext, useCallback, useContext, useMemo, useRef, useState } from 'react';

const QuoteContext = createContext(null);

export const QuoteProvider = ({ children }) => {
  const [symbol, setSymbol] = useState('');
  const [asset, setAsset] = useState(null);
  const orderSubmittedHandlersRef = useRef(new Set());

  const selectSymbol = useCallback((nextSymbol, nextAsset = null) => {
    const normalized = String(nextSymbol || '').trim().toUpperCase();
    if (!normalized) {
      setSymbol('');
      setAsset(null);
      return;
    }
    setSymbol(normalized);
    setAsset(nextAsset && nextAsset.symbol === normalized ? nextAsset : { symbol: normalized, ...(nextAsset || {}) });
  }, []);

  const registerOrderSubmitted = useCallback((handler) => {
    orderSubmittedHandlersRef.current.add(handler);
    return () => {
      orderSubmittedHandlersRef.current.delete(handler);
    };
  }, []);

  const notifyOrderSubmitted = useCallback((order) => {
    orderSubmittedHandlersRef.current.forEach((handler) => handler(order));
  }, []);

  const value = useMemo(
    () => ({ symbol, asset, selectSymbol, registerOrderSubmitted, notifyOrderSubmitted }),
    [symbol, asset, selectSymbol, registerOrderSubmitted, notifyOrderSubmitted]
  );

  return <QuoteContext.Provider value={value}>{children}</QuoteContext.Provider>;
};

export const useQuote = () => {
  const context = useContext(QuoteContext);
  if (!context) {
    throw new Error('useQuote must be used within a QuoteProvider');
  }
  return context;
};
